import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Heart, Ban } from "lucide-react";

export default function CompanionsList({ name, category }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!name) return;
    const q = category ? `?category=${encodeURIComponent(category)}` : "";
    api.get(`/companions/${encodeURIComponent(name)}${q}`).then((r) => setData(r.data));
  }, [name, category]);

  if (!data) return null;
  const has = (data.friends?.length || 0) + (data.foes?.length || 0) > 0;

  return (
    <div className="sage-card p-6" data-testid="companions-list">
      <div className="label-overline mb-2">Companion lore</div>
      <h3 className="font-serif text-2xl font-light mb-4">Who to plant beside {name}</h3>
      {has ? (
        <>
          <div className="space-y-3">
            <div>
              <div className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-primary mb-1.5">
                <Heart className="w-3.5 h-3.5" strokeWidth={1.6} /> Friends
              </div>
              <div className="flex flex-wrap gap-1.5">
                {(data.friends || []).map((f) => (
                  <span key={f} className="text-xs px-2 py-1 rounded-md bg-primary/10 text-primary border border-primary/15" data-testid={`friend-${f}`}>{f}</span>
                ))}
                {(data.friends || []).length === 0 && <span className="text-xs text-muted-foreground italic">— none recorded</span>}
              </div>
            </div>
            <div>
              <div className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-destructive mb-1.5">
                <Ban className="w-3.5 h-3.5" strokeWidth={1.6} /> Foes
              </div>
              <div className="flex flex-wrap gap-1.5">
                {(data.foes || []).map((f) => (
                  <span key={f} className="text-xs px-2 py-1 rounded-md bg-destructive/10 text-destructive border border-destructive/15" data-testid={`foe-${f}`}>{f}</span>
                ))}
                {(data.foes || []).length === 0 && <span className="text-xs text-muted-foreground italic">— none recorded</span>}
              </div>
            </div>
          </div>
          {data.why && <p className="text-xs text-foreground/70 mt-4 leading-relaxed italic">{data.why}</p>}
        </>
      ) : (
        <p className="text-xs text-muted-foreground italic">{data.why}</p>
      )}
    </div>
  );
}
